























































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { dictServe, doublePrevention, panoramicQueryServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: {},
  filters: {
    ChangeType(type: string) {
      switch (type) {
        case 'add':
          return '新增';
        case 'edit':
          return '编辑';
        case 'detail':
          return '详情';
      }
    },
  },
})
export default class PublicPage extends Vue {
  @Prop(Object) row: any;
  @Prop(String) type: any;
  private canEdit = false; // 详情页不可编辑

  private dialogVisible = false;
  private pathFile: any = '';

  private planClassificationList: any = [];
  private planLevelList: any = [];
  private userAreaList: any = [];

  formRules: any = {
    // companyPlaceType: [{ required: true, message: '请选择企业场所类型', trigger: 'change' }],
    // companyName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
  };

  private formData: any = {
    applicationForm: '',
    businessLicense: '',
    directorIdentityCard: '',
    electronicDocuments: '',
    emergencyResourcesDetail: '',
    expertCertification: '',
    operatorIdentityCard: '',
    planClassification: '',
    planLevel: '',
    planName: '',
    qualificationCertificate: '',
    riskAssessmentResults: '',
    userArea: '',
  };

  private applicationFormFileList: any = []; // 预案备案申请表
  private businessLicenseFileList: any = []; // 企业营业执照附件
  private directorIdentityCardFileList: any = []; // 主要负责人身份证复印件
  private electronicDocumentsFileList: any = []; // 应急预案电子文档
  private emergencyResourcesDetailFileList: any = []; // 应急资源调查清单文本和电子文档
  private expertCertificationFileList: any = []; // 评审专家的专家证复印件
  private operatorIdentityCardFileList: any = []; // 生产经营单位经办人身份证复印件
  private qualificationCertificateFileList: any = []; // 资质证书附件
  private riskAssessmentResultsFileList: any = []; // 风险评估结果
  private headers: any = {};
  private actionUrl: any = ''; // 图片上传
  private uploadUrl: any = ''; // 图片上传
  picList: any = [];
  private serverUrl = publishObjectPath.imgPathWater;

  created() {
    this.getDictTypeOption('emergencyPlanType');
    this.getDictTypeOption('emergencyPlanGrade');
    this.getDictTypeOption('emergencyPlanArea');
    if (this.row.type === 'add') {
      this.formData = {
        applicationForm: '',
        businessLicense: '',
        directorIdentityCard: '',
        electronicDocuments: '',
        emergencyResourcesDetail: '',
        expertCertification: '',
        operatorIdentityCard: '',
        planClassification: '',
        planLevel: '',
        planName: '',
        qualificationCertificate: '',
        riskAssessmentResults: '',
        userArea: '',
      };
    }
    if (this.row.type === 'edit') {
      this.getDetail(); // 详情
    }
    if (this.row.type === 'detail') {
      this.canEdit = true;
      this.getDetail(); // 详情
    }
  }

  mounted() {
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile/annex';
    this.uploadUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile';
    this.headers.Authorization = localStorage.getItem('token');
  }

  private beforeClose() {
    this.dialogVisible = false;
  }
  private handlePreview(file: any) {
    // console.log(file);
    // this.dialogVisible = true;
    // if (file.response) {
    //   this.pathFile = this.serverUrl + file.response.data[0].path;
    // } else {
    //   this.pathFile = this.serverUrl + file.path;
    // }
    const urlPath: any = publishObjectPath.imgPathWater + file.path;
    this.getBlob(urlPath).then((blob: any) => {
      this.saveAs(blob, file.name);
    });
  }
  getBlob = (url: any) => {
    return new Promise((resolve: any) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        if (xhr.status == 200) {
          resolve(xhr.response);
        }
      };
      xhr.send();
    });
  };
  saveAs = (blob: any, name: any) => {
    const url = window.URL.createObjectURL(blob);
    const aLink = document.createElement('a');
    aLink.style.display = 'none';
    aLink.href = url;
    aLink.setAttribute('download', name);
    document.body.appendChild(aLink);
    aLink.click();
    document.body.removeChild(aLink); // 下载完成移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
  };

  private handleApplicationFormSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.applicationForm = arr.toString();
  }
  private handleApplicationFormRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.applicationForm = arr.toString();
  }

  private handleBusinessLicenseSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.businessLicense = arr.toString();
  }

  private handleBusinessLicenseRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.businessLicense = arr.toString();
  }
  private handleElectronicDocumentsSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.electronicDocuments = arr.toString();
  }
  private handleElectronicDocumentsRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.electronicDocuments = arr.toString();
  }
  private handleEmergencyResourcesDetailSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.emergencyResourcesDetail = arr.toString();
  }
  private handleEmergencyResourcesDetailRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.emergencyResourcesDetail = arr.toString();
  }
  private handleDirectorIdentityCardSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.directorIdentityCard = arr.toString();
  }
  private handleDirectorIdentityCardRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.directorIdentityCard = arr.toString();
  }
  private handleExpertCertificationSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.expertCertification = arr.toString();
  }
  private handleExpertCertificationRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.expertCertification = arr.toString();
  }
  private handleOperatorIdentityCardSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.operatorIdentityCard = arr.toString();
  }
  private handleOperatorIdentityCardRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.operatorIdentityCard = arr.toString();
  }
  private handleRiskAssessmentResultsSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.riskAssessmentResults = arr.toString();
  }
  private handleRiskAssessmentResultsRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.riskAssessmentResults = arr.toString();
  }
  private handleQualificationCertificateSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.qualificationCertificate = arr.toString();
  }
  private handleQualificationCertificateRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.formData.qualificationCertificate = arr.toString();
  }
  // 详情
  private getDetail() {
    doublePrevention.getSingleEnterpriseEmergencyPlan(this.row.id).then((res: any) => {
      if (res.code === '200') {
        this.formData = res.data;
        this.applicationFormFileList = res.data.applicationFormFile || [];
        this.businessLicenseFileList = res.data.businessLicenseFile || [];
        this.electronicDocumentsFileList = res.data.electronicDocumentsFile || [];
        this.emergencyResourcesDetailFileList = res.data.emergencyResourcesDetailFile || [];
        this.qualificationCertificateFileList = res.data.qualificationCertificateFile || [];
        this.riskAssessmentResultsFileList = res.data.riskAssessmentResultsFile || [];
        this.directorIdentityCardFileList = res.data.directorIdentityCardFile || [];
        this.expertCertificationFileList = res.data.expertCertificationFile || [];
        this.operatorIdentityCardFileList = res.data.operatorIdentityCardFile || [];
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  private submitForm() {
    const formComponent: any = this.$refs['form'];
    formComponent.validate((valid: any) => {
      if (valid) {
        if (this.row.type === 'add') {
          this.addFunction();
        } else if (this.row.type === 'edit') {
          this.editFunction();
        }
      }
    });
  }
  private addFunction() {
    doublePrevention
      .addEnterpriseEmergencyPlan(this.formData)
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('新增成功');
          this.close();
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {});
  }
  private editFunction() {
    doublePrevention
      .editEnterpriseEmergencyPlan(this.row.id, {
        applicationForm: this.formData.applicationForm,
        businessLicense: this.formData.businessLicense,
        directorIdentityCard: this.formData.directorIdentityCard,
        electronicDocuments: this.formData.electronicDocuments,
        emergencyResourcesDetail: this.formData.emergencyResourcesDetail,
        expertCertification: this.formData.expertCertification,
        operatorIdentityCard: this.formData.operatorIdentityCard,
        planClassification: this.formData.planClassification,
        planLevel: this.formData.planLevel,
        planName: this.formData.planName,
        qualificationCertificate: this.formData.qualificationCertificate,
        riskAssessmentResults: this.formData.riskAssessmentResults,
        userArea: this.formData.userArea,
        id: this.formData.id,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.$message.success('编辑成功');
          this.close();
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {});
  }

  // 编辑
  private modifyRiskControlInventory() {
    panoramicQueryServer
      .addOrEditInfoConfig({ ...this.formData })
      .then((res: any) => {
        if (res.code === '200') {
          if (this.type === 'add') {
            this.$message.success('数据新增成功！');
          } else {
            this.$message.success('数据编辑成功！');
          }
          this.close();
        } else {
          this.$message.warning(res.msg);
        }
      })
      .catch((error: any) => {
        if (this.type === 'add') {
          this.$message.error('数据新增失败！');
        } else {
          this.$message.error('数据编辑失败！');
        }
      });
  }

  // 获取企业类型
  private getDictTypeOption(name: any) {
    const dictTypeList: any = [];
    dictServe
      .getDetailsMapByName(name)
      .then((res: any) => {
        for (const key in res.data) {
          dictTypeList.push({
            id: key,
            label: res.data[key],
            value: res.data[key],
          });
        }
        if (name === 'emergencyPlanType') {
          this.planClassificationList = dictTypeList;
        } else if (name === 'emergencyPlanGrade') {
          this.planLevelList = dictTypeList;
        } else if (name === 'emergencyPlanArea') {
          this.userAreaList = dictTypeList;
        }
      })
      .catch((error: any) => {
        this.$message.warning('获取数据失败!');
      });
  }

  private close() {
    this.$emit('on-response');
    this.canEdit = false;
    this.applicationFormFileList = [];
    this.businessLicenseFileList = [];
    this.directorIdentityCardFileList = [];
    this.electronicDocumentsFileList = [];
    this.emergencyResourcesDetailFileList = [];
    this.expertCertificationFileList = [];
    this.operatorIdentityCardFileList = [];
    this.qualificationCertificateFileList = [];
    this.riskAssessmentResultsFileList = [];
  }
}
